import { render } from "./SelectReference.vue?vue&type=template&id=5457451a&scoped=true"
import script from "./SelectReference.vue?vue&type=script&lang=js"
export * from "./SelectReference.vue?vue&type=script&lang=js"

import "./SelectReference.vue?vue&type=style&index=0&id=5457451a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5457451a"]])

export default __exports__